import React, { useEffect } from "react";
import { IoAddOutline, IoCloseOutline } from "react-icons/io5";

import { timeOptions, toogleWeeks } from "../tool";
import { normalizeBranchOperatingHours } from "../branchOperatingHours";

const EditTime = ({ form, setForm, setData }) => {
    const hours = normalizeBranchOperatingHours(form.branch_operating_hours);

    const handleCheckboxChange = (i) => {
        setForm((data) => {
            const base = normalizeBranchOperatingHours(data.branch_operating_hours);
            return {
                ...data,
                branch_operating_hours: {
                    ...base,
                    [i]: {
                        ...base[i],
                        open: !base[i].open,
                    },
                },
            };
        });
    };
    const handleAddTimeSlot = (day) => {
        setForm((data) => {
            const base = normalizeBranchOperatingHours(data.branch_operating_hours);
            if (base[day].time.length >= 3) return data;
            const newTimeSlot = ["00:00", "00:00"];
            return {
                ...data,
                branch_operating_hours: {
                    ...base,
                    [day]: {
                        ...base[day],
                        time: [...base[day].time, newTimeSlot],
                    },
                },
            };
        });
    };

    const handleRemoveTimeSlot = (day, indexToRemove) => {
        setForm((data) => {
            const base = normalizeBranchOperatingHours(data.branch_operating_hours);
            return {
                ...data,
                branch_operating_hours: {
                    ...base,
                    [day]: {
                        ...base[day],
                        time: [
                            ...base[day].time.slice(0, indexToRemove),
                            ...base[day].time.slice(indexToRemove + 1),
                        ],
                    },
                },
            };
        });
    };

    const handleSelectChange = (day, index, field, value) => {
        setForm((data) => {
            const base = normalizeBranchOperatingHours(data.branch_operating_hours);
            return {
                ...data,
                branch_operating_hours: {
                    ...base,
                    [day]: {
                        ...base[day],
                        time: base[day].time.map((slot, i) => {
                            if (i === index) {
                                return [
                                    ...slot.slice(0, field),
                                    value,
                                    ...slot.slice(field + 1),
                                ];
                            }
                            return slot;
                        }),
                    },
                },
            };
        });
    };

    useEffect(() => {
        setData((i) => ({
            ...i,
            branch_operating_hours: normalizeBranchOperatingHours(form.branch_operating_hours),
        }));
    }, [setData, form.branch_operating_hours]);

    return (
        <div className="edit-warp-content-time">
            <ul>{['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].map((item, index) => (
                <li key={index}>
                    <div>
                        <input type="checkbox" checked={hours[item].open} onChange={() => handleCheckboxChange(item)} />
                        <p>{toogleWeeks[item]}</p>
                    </div>

                    {hours[item].open ? (
                        <ul>{hours[item].time.map((e, i) => (
                            <li key={i}>
                                <div>
                                    <select defaultValue={e[0]} onChange={(event) => handleSelectChange(item, i, 0, event.target.value)}>
                                        {timeOptions.map((v, d) => (
                                            <option key={d}>{v}</option>
                                        ))}
                                    </select>

                                    -

                                    <select defaultValue={e[1]} onChange={(event) => handleSelectChange(item, i, 1, event.target.value)}>
                                        {timeOptions.map((v, d) => (
                                            <option key={d}>{v}</option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    {i === hours[item].time.length - 1 && hours[item].time.length < 3 && (
                                        <button type="button" onClick={() => handleAddTimeSlot(item)}>
                                            <IoAddOutline size={24} color="#4A546B" />
                                        </button>
                                    )}

                                    {hours[item].time.length !== 1 && (
                                        <button type="button" onClick={() => handleRemoveTimeSlot(item, i)}>
                                            <IoCloseOutline size={24} color="#e75264" />
                                        </button>
                                    )}
                                </div>
                            </li>
                        ))}</ul>
                    ) :
                        <p>CLOSED</p>
                    }</li>
            ))}</ul>
        </div>
    );
};

export default EditTime;
